
import zhLocale from 'element-ui/lib/locale/lang/zh-CN' //引入element语言包
//需要转换的中文
const cn = {
  message: {
    info: {
    in1:"下载",
      in2: "快捷交易",
      in3:"能量秒到账",
      in4:"租期更长，最长30天",
      in5:"范围更大，支持3.2 万起租",
      in6:"支持多币种支付购买",
      in7:"支持DAPP支付和转账租赁",
      in8:"可以预定大额能量",
      in9:"剩余可租能量",
      in10:"能量租赁",
      in11:"接收地址",
      in12:"连接钱包获取地址",
      in13:"请选择地址",
      in14:"资源租用数量",
      in15: "预估可转账USDT",
      in16: "请输入数量",
      in17:"资源租用时间",
      in18:"预计",
      in19:"到期被系统回收",
      in20:"支付",
      in21:"订单信息",
      in22:"能量",
      in23:"单价",
      in24:"较",
      in25:"烧毁省",
      in26:"详情",
      in27:"订单金额",
      in28:"订单时长",
      in29:"租用数量",
      in30: "节 省",
      in31:" 折 扣",
      in32:"接收地址",
      in33:"钱包支付",
      in34:"连接钱包支付",
      in35:"地址余额支付",
      in36:"推荐",
      in37:"账户余额支付",
      in38:"地址支付",
      in39:"使用链上钱包进行转账支付",
      in40:"请在有效的时间内支付",
      in41:"到账金额需要与下方显示的金额一致，否则系统无法确认",
      in42:"监控支付中",
      in43:"复制收款地址",
      in44: "复制支付TRX数量",
      in45:"复制支付USDT数量",
      in46:"复制成功",
      in47:"复制失败",
      in48:"支付成功",
      in49:"支付取消",
      in50:"请先连接 TronLink 钱包",
      in51:"连接操作频繁，请手动连接钱包",
      in52:"连接钱包被取消",
      in53:"交易失败",
      in54:"请输入接收地址",
      in55:"请选择租用时间",
      in56:"能量租赁",
      in57:"首页",
      in58: "能量租用",
      in59:"租用记录",
      in60:"API文档",
      in61:"APP下载",
      in62:"个人中心",
      in63:"登录",
      in64:"更改密码",
      in65:"退出登录",
      in66:"新密码",
      in67:"确认密码",
      in68:"提交",
      in69:"请输入密码",
      in70:"请再次输入密码",
      in71:"两次输入密码不一致",
      in72: "能量交易平台",
      in73:"便宜、 便捷、 快速、 高效、 安全",
      in74:"是一个TRON 能量交易平台，我们提供TRON能量交易服务，让TRON能量交易更加便捷、安全、快速",
      in75:"平台下单",
      in76:"操作简单",
      in77:"数据详细",
      in78:"支持扫码付款",
      in79:"Dapp付款",
      in80:"前往下单",
      in81:"Android下单",
      in82:"IOS下单",
      in83:"API下单",
      in84:"什么是能量？能量是免费的吗？",
      in85:"TRON网络中的资源有3种:带宽,能量,存储。得益于波场独有的设计模型,TRON网络中的存储资源几乎是无限的。TRON网络引入了Bandwidth Point 和 Energy 两种可以进行量化的资源。其中Bandwidth Point表示带宽资源,Energy表示能量资源。",
      in86: "我们在比特币、以太坊上转账时需要通过 BTC、ETH 来支付手续费。在波场进行转账时消耗的是带宽和能量。",
      in87:"比特币和以太坊立下的规矩是,代币转账需要用 BTC 和 ETH 来支付,而波场立下的规矩则是用能量和带宽来支付。波场上有两类常见租客(两类常见的代币格式):TRC-10 和 TRC-20。转账 TRX 和 TRC-10 代币时需要消耗带宽,转账 TRC-20 代币时需要消耗带宽和能量。",
      in88:"如果你不知道代币格式,可以在资产首页点击该代币,进入交易记录界面后再点击右上角,进入 TRONSCAN 即可查看其代币格式,例如波场上的 USDT 就是 TRC-20 格式",
      in89:" 波场账户能量不是免费的,需要冻结TRX获取能量。也可以向能量交易平台租能量。假如账户中有100万能量,使用完毕后,会慢慢恢复,24小时恢复满100万。冻结(租用)默认最少1小时,当1小时后账户取消冻结(租用到期)时,通过冻结(租用)获得的能量也将自动清零。",
      in90:"能量有什么用？",
      in91:"能量主要可在以下几种场景用于消耗(以下消耗数据为链上数据概揽,为大概数据,实际准确消耗数据需操作之后区块浏览器查询所得数据。",
      in92:"消耗",
      in93:" TRC20代币,消耗带宽和能量,例如USDT是20代币,转账一笔需消耗31895能量和345带宽,需要抵扣能量13.39TRX和带宽0.345TRX左右。",
      in94:" 智能合约 消耗",
      in95:"调用智能合约,需消耗带宽和能量。例如SUNSWAP买卖交易,均是智能合约交互,需消耗账户中的能量和带宽。",
      in96:"如何获得能量？",
      in97:"方法一:燃烧 TRX",
      in98:"如果账号没有足够能量,转账时会自动燃烧 TRX 以抵扣转账所需的带宽和能量。相比消耗能量,燃烧TRX显然并不划算。",
      in99:"方法二:冻结 TRX",
      in100: "点击资产首页的能量 / 带宽,进入 Tron 资源管理界面,选择想获得的资源类型,输入需冻结的 TRX 数量,获得的能量 = 冻结的TRX / 全网获得能量冻结的总TRX *总能量限制。(这是基于冻结的TRX为所有用户平均分配的固定能量),冻结后的 TRX 在 3 天后可以解冻取回。如果您有大量闲置TRX,可以考虑这种方法。",
      in101:"方法三:租用能量",
      in102:"可以通过本平台进行能量租赁的方式来节省手续费,能量租赁既不需要冻结大量TRX,也不用燃烧更多TRX,还可节省至少80%的手续费,以租用100万能量为例,若直接燃烧TRX,3天需要燃烧大约1266TRX,使用用本平台租用100万能量只需要120TRX左右,节省了90%≈1140TRX。",
      in103:"如何租用能量？",
      in104:"可以通过本平台去",
      in105:"租用能量",
      in106:"支付成功后，能量什么时候到账？",
      in107:"付款完成后,能量最快3秒内到账。由于广播延迟等原因,极少数情况,会存在5到10分钟的延迟。",
      in108:"能量使用后多久能恢复满？",
      in109:"能量使用后将会在24小时内恢复满。",
      in110:"订单可以撤回吗？",
      in111:"订单生成后,暂不支持撤回",
      in112:"tel能量群",
      in113:"客服",
      in114: "复制成功",
      in115:"复制失败",
      in116:"请输入邮箱",
      in117:"请输入验证码",
      in118:"获取验证码",
      in119:"请输入邮箱",
      in120:"请输入密码",
      in121:"确定",
      in122:"密码登录",
      in123:"验证码登录",
      in124:"请输入正确的邮箱",
      in125:"验证码已发送",
      in126:"请输入密码",
      in127:"余额：",
      in128: "充值",
      in129:"余额明细",
      in130:"订单金额",
      in131:"余额变更前",
      in132:"余额变更后",
      in133:"订单编号",
      in134:"操作时间",
      in135:"请使用波场浏览器或手机钱包进行转账。",
      in136:"请核对钱包地址后再转账,若转账后没查到充值金额,可联系客服找回。",
      in137:"转账金额必须大于1TRX。",
      in138:"当前地址仅支持TRX或USDT(TRC20)转账。",
      in139:"下单",
      in140:"状态查询",
      in141:"配置查询",
      in142: "余额查询",
      in143:"订单进度",
      in144:"资源类型",
      in145:"能量",
      in146:"租用时间",
      in147:"完成数量",
      in148:"接收地址",
      in149:"创建时间",
      in150:"回收时间",
      in151:"代理Hash",
      in152:"查看",
      in153:"暂无数据",
      in154:"次",
      in155:"支付倒计时",
      in156: "消费TRX",
      in157:"下单接口",
      in158:"请求数据",
      in159:"账户",
      in160:"密码",
      in161:"能量接收地址",
      in162:"能量数量，整数",
      in163:"租用时长 h代表小时d代表天数 仅支持1h、1d、3d及更多天数时间",
      in164:"返回数据：code=200是成功，其他为失败",
      in165:"订单状态 通过订单号去查询",
      in166:"状态查询接口",
      in167:"租用能量数",
      in168:"订单编号",
      in169:"租用地址",
      in170: "单价SUN",
      in171:"租用时长",
      in172:"付款金额trx",
      in173:"租用Hash",
      in174:"租用状态 1未租用 2租用中 3租用成功 4租用失败",
      in175:"配置查询接口",
      in176:"下单最小数量",
      in177:"当前剩余能量额度",
      in178:"是否可以下单",
      in179:"1小时单价SUN",
      in180:"1天单价SUN",
      in181:"3天单价SUN",
      in182:"其他单价SUN",
      in183:"余额查询接口",
      in184: "能量转租",


      in185:"详情",
      in186:"佣金：",
      in187:"提现",
      in188:"新增转租",
      in189:"能量开关",
      in190:"绑定地址",
      in191:"订单编号",
      in192:"转租配置",
      in193:"能量",
      in194:"价格",
      in195:"最大翻倍",
      in196:"订单备注",
      in197:"创建时间",
      in198:"操作",
      in199:"同步到机器人",
      in200:"删除",
      in201:"确认删除吗？",
      in202:"提示",
      in203:"确定",
      in204:"取消",
      in205:"绑定转账地址",
      in206:"请输入资源接收地址",
      in207:"转租能量配置",
      in208:"能量数量",
      in209:"请输入能量数量",
      in210:"TRX价格",
      in211:"请输入TRX价格",
      in212:"最大翻倍",
      in213:"请输入最大翻倍数",
      in214:"删除",
      in215:"增加",
      in216:"订单备注",
      in217:"请填写订单备注，选填",
      in218:"保存",
      in219:"下一步",
      in220: "推荐码,非必填",
      in221:"管理",
      in222:"地址管理",
      in223:"佣金余额明细",
      in224:"添加",
      in225:"添加地址",
      in226: "请输入地址",
      in227:"系统公告",
      in228: "公告",
      in229:"通过将自已账号中的余额转租给他人，赚取差价。请在上面设置中设置您的收取trx的地址及每次转租价格和数量通常为65000和131000",
      in230:"邀请好友",
      in231:"我的推荐码",
      in232:"我的推荐链接",
      in233: "二维码邀请",
      
      in234:"电报机器人",
      in235:"请输入机器人用户名",
      in236:"请输入机器人Token",
      in237: "请输入客服http(s)地址",
      in238:"机器人用户名",
      in239:"机器人ID",
      in240:"机器人Token",
      in241: "闪租地址",
      in242:"闪租配置",
      in243:"机器人状态",
      in244:"已启用",
      in245:"未启用",
      in246:"编辑",
      in247:"启用",
      in248:"停止",
      in249:"重启",
      in250:"保存",
      in251:"配置机器人",
      in252:"客服",
      in253:"",
      in254:"",
      in255:"",
      in256:"",
      in257:"",
      in258:"",
      in259:"",
      in260:"",
      in261:"",
      in262:"",
      in263:"",
      in264:"",
      in265:"",
      in266:"",
      in267:"",
      in268:"",
      in269:"",
      in270:"",
      in271:"",
      in272:"",
      in273:"",
      in274:"",
      in275:"",
      in276:"",
      in277:"",
      in278:"",
      in279:"",
      in280:"",
      in281:"",
      in282:"",
      in283:"",
      in284:"",
      in285:"",
      in286:"",
      in287:"",
      in288:"",
      in289:"",
      in290:"",
      in291:"",
      in292:"",
      in293:"",

   
    },

    
  },
  ...zhLocale
}
export default cn;



// WEBPACK FOOTER //
// ./src/assets/i18n/langs/zh_CN.js